import { Component, OnInit, Input } from '@angular/core';
import { EvsUserService } from '../../../../../../common/services/EvsUser.service';
import { EvsStoreService } from '../../../../../../common/services/EvsStore.service';
import { EvsAddressService } from '../../../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationService, Message } from 'primeng/primeng';
declare var $: any;

@Component({
  selector: 'app-distribution-manager',
  templateUrl: './distribution-manager.component.html',
  styleUrls: ['./distribution-manager.component.css'],
  providers: [EvsUserService, EvsStoreService, EvsAddressService, ConfirmationService]
})
export class DistributionManagerComponent implements OnInit {

  constructor(
    private evsUserService: EvsUserService,
    private evsStoreService: EvsStoreService,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    private confirmationService: ConfirmationService,
  ) { }
  @Input('user') user: any;

  public cities: Array<any> = [];
  store: any = {};
  listStore: any = []
  storeFocus: boolean = false;

  stores: any = [];
  areas: any = []
  page_size: number = 10;
  storeOffset: number = 0;
  areaOffset: number = 0;
  storeCurrentPage: number = 1;
  areaCurrentPage: number = 1;
  ngOnInit() {
    let province = $('#province_distribution');
    province.select2({ placeholder: "-- Tỉnh/TP --", allowClear: false, width: '100%' });
    this.getCity();
    this.getData();
  }
  getCity() {
    this.addressService.getCities().subscribe(res => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }
  getData() {
    let request: any = {};
    request.offset = this.page_size * (this.storeCurrentPage <= 0 ? 0 : this.storeCurrentPage - 1);
    request.limit = this.page_size;
    request.type = 'distribution'
    this.evsUserService.getMaganerPermission(this.user.id, request)
      .subscribe(res => {
        if (!res.error) {
          this.stores = res.data.distribution.stores;
          this.areas = res.data.distribution.cities;
        }
      })
  }
  searchStore() {
    if (this.store.name) {
      let request: any = {
        limit: 100,
        offset: 0,
        name: this.store.name
      }
      this.evsStoreService.all(request)
        .subscribe(res => {
          if (!res.error) {
            console.log(res)
            if (res.data) {
              this.listStore = res.data.store;
            } else this.listStore = [];
          }
        })
    }

  }
  focusoutStore() {
    setTimeout(() => {
      this.storeFocus = false;
    }, 200)
  }

  addStore() {
    if (this.store.id) {
      let data: any = {
        distribution: {
          store: this.store.id
        }
      };
      this.evsUserService.postMaganerPermission(this.user.id, data)
        .subscribe(res => {
          if (!res.error) {
            this.toastr.success('Thêm quyền cửa hàng thành công!');
            this.storePage();
          }
        })
    }
  }
  addArea() {
    if ($('#province_distribution').val()) {
      let city = parseInt($('#province_distribution').val());
      let data: any = {
        distribution: {
          city: city
        }
      };
      this.evsUserService.postMaganerPermission(this.user.id, data)
        .subscribe(res => {
          if (!res.error) {
            this.toastr.success('Thêm quyền khu vực phân phối thành công!');
            this.areaPage();
          }
        })
    }
  }
  storePage() {
    let request: any = {};
    request.offset = this.page_size * (this.storeCurrentPage <= 0 ? 0 : this.storeCurrentPage - 1);
    this.storeOffset = request.offset;
    request.limit = this.page_size;
    request.type = 'distribution'
    this.evsUserService.getMaganerPermission(this.user.id, request)
      .subscribe(res => {
        if (!res.error) {
          this.stores = res.data.distribution.stores;
          console.log(this.stores)
          if (this.storeCurrentPage > 1 && (!this.stores || this.stores.length == 0)) {
            this.storeCurrentPage--;
            this.storePage();
            this.toastr.warning('Bạn đang ở trang cuối cùng');
          }
        }
      })
  }
  areaPage() {
    let request: any = {};
    request.offset = this.page_size * (this.areaCurrentPage <= 0 ? 0 : this.areaCurrentPage - 1);
    this.areaOffset = request.offset;
    request.limit = this.page_size;
    request.type = 'distribution'
    this.evsUserService.getMaganerPermission(this.user.id, request)
      .subscribe(res => {
        if (!res.error) {
          this.areas = res.data.distribution.cities;
          if (this.areaCurrentPage > 1 && (!this.areas || this.areas.length == 0)) {
            this.areaCurrentPage--;
            this.areaPage();
            this.toastr.warning('Bạn đang ở trang cuối cùng');
          }
        }
      })
  }
  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }
  deleteStore(store) {
    this.confirmationService.confirm({
      message: 'Bạn chắc chắn muốn xóa quyền quản lý cửa hàng này ?',
      header: 'Xác nhận',
      icon: 'fa fa-trash',
      accept: () => {
        if (store.id) {
          let data: any = {
            distribution: {
              store: store.id
            }
          };
          this.evsUserService.deleteMaganerPermission(this.user.id, data)
            .subscribe(res => {
              if (!res.error) {
                this.toastr.info('Bạn vừa xóa quyền quản lý cửa hàng ' + store.name);
                this.storePage();
              }
            })
        }

      }
    });
  }
  deleteArea(area) {
    this.confirmationService.confirm({
      message: 'Bạn chắc chắn muốn xóa quyền quản lý khu vực phân phối này ?',
      header: 'Xác nhận',
      icon: 'fa fa-trash',
      accept: () => {
        if (area.id) {
          let data: any = {
            distribution: {
              city: area.id
            }
          };
          this.evsUserService.deleteMaganerPermission(this.user.id, data)
            .subscribe(res => {
              if (!res.error) {
                this.toastr.info('Bạn vừa xóa quyền quản lý khu vực phân phối ' + area.name);
                this.areaPage();
              }
            })
        }

      }
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/modal-manager/distribution-manager/distribution-manager.component.ts